import React from 'react';
import classNames from 'classnames';

import css from './IconPetPaw.module.css';

/**
 * IconPetPaw icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconPetPaw = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
<svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
<path fillRule="evenodd" clipRule="evenodd" d="M7.96139 0C7.11493 0 6.4094 0.452691 5.94342 1.06466C5.47798 1.67594 5.21485 2.4827 5.21485 3.3385C5.21485 4.19429 5.47798 5.00107 5.94342 5.61233C6.4094 6.2243 7.11493 6.67699 7.96139 6.67699C8.80786 6.67699 9.51337 6.2243 9.97935 5.61233C10.4448 5.00107 10.7079 4.19429 10.7079 3.3385C10.7079 2.4827 10.4448 1.67594 9.97935 1.06466C9.51337 0.452691 8.80786 0 7.96139 0ZM15.0496 0C14.2031 0 13.4976 0.452691 13.0316 1.06466C12.5662 1.67594 12.303 2.4827 12.303 3.3385C12.303 4.19429 12.5662 5.00107 13.0316 5.61233C13.4976 6.2243 14.2031 6.67699 15.0496 6.67699C15.896 6.67699 16.6015 6.2243 17.0675 5.61233C17.5329 5.00107 17.796 4.19429 17.796 3.3385C17.796 2.4827 17.5329 1.67594 17.0675 1.06466C16.6015 0.452691 15.896 0 15.0496 0ZM20.1674 6.29988C18.4291 6.29988 17.325 7.98279 17.325 9.63837C17.325 11.2939 18.4291 12.9769 20.1674 12.9769C21.9059 12.9769 23.01 11.2939 23.01 9.63837C23.01 7.98279 21.9059 6.29988 20.1674 6.29988ZM2.84255 6.29988C1.10417 6.29988 0 7.98279 0 9.63837C0 11.2939 1.10417 12.9769 2.84255 12.9769C4.58092 12.9769 5.6851 11.2939 5.6851 9.63837C5.6851 7.98279 4.58092 6.29988 2.84255 6.29988ZM11.5051 9.47095C9.50656 9.47095 8.02947 10.5426 7.08476 11.8699C6.15351 13.1783 5.68527 14.7998 5.68527 16.1179C5.68527 17.6606 6.61285 18.7319 7.74486 19.3739C8.85959 20.0059 10.255 20.2835 11.5051 20.2835C12.7552 20.2835 14.1506 20.0059 15.2653 19.3739C16.3974 18.7319 17.325 17.6606 17.325 16.1179C17.325 14.7998 16.8566 13.1783 15.9254 11.8699C14.9807 10.5426 13.5036 9.47095 11.5051 9.47095Z" fill="#262338"/>
</svg>

  );
};

export default IconPetPaw;
